module.exports = __webpack_public_path__ + "img/a1-1.2e015fc7.png";